import { Dot } from "components/Dot";
import LinkShowToTravelButton, { type LinkShowToTravelConfig } from "components/LinkShowToTravelButton";
import LinkedShowLines from "components/LinkedShows/LinkedShowElement";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import React from "react";
import { ShowSidePanel } from "./Show/ShowSidePanel";

interface SidePanelLinkedShowListProps {
  linkedShows: server.dto.LinkedShow[]
  linkShowToTravel: LinkShowToTravelConfig
}

export const SidePanelLinkedShowList = (props: SidePanelLinkedShowListProps) => {
  const items = props.linkedShows || [];
  const renderLinkShowToTravelButton = () => {
    const linkShowToTravel = props.linkShowToTravel;

    if (linkShowToTravel == null || !linkShowToTravel.canLink) {
      return undefined;
    }

    return <LinkShowToTravelButton
      travelType={linkShowToTravel.travelType}
      travelId={linkShowToTravel.travelId}
      appointmentDateTime={linkShowToTravel.appointmentDateTime}
      artist={linkShowToTravel.artist}
      linkedShowIds={linkShowToTravel.linkedShowIds}
      onLinked={linkShowToTravel.onLinked}
    />;
  };

  return <div className="flex-column gap">
    <div className="flex">
      <h3 className="grow1">{site.currentEnvironment.show.plural}</h3>
      {renderLinkShowToTravelButton()}
    </div>
    {items.length === 0 && <NoDataAvailableDiv />}

    {items.length > 0 && <>
      {items.map(show => <ShowSidePanel
        canEdit
        showId={show.showId}
        key={show.showId}
        trigger={<a className="flex gap-small linked-show-row linked-show-link regular" style={{ cursor: "pointer", textDecoration: "none" }}>
          <div>
            <Dot color={show.status.hexColor} />
          </div>
          <div>
            <LinkedShowLines {...show} format={"regular"} />
          </div>
        </a>}
      />)}
    </>}
  </div>
}
